export { default as Img200 } from './processed/200/Robin-Hood.jpg';
export { default as Img400 } from './processed/400/Robin-Hood.jpg';
export { default as Imgthumb } from './processed/thumb/Robin-Hood.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Robin-Hood.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Robin-Hood.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      252,
      212,
      84
    ],
    "_population": 1,
    "_hsl": [
      0.12698412698412695,
      0.9655172413793105,
      0.6588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      247,
      212,
      143
    ],
    "_population": 604,
    "_hsl": [
      0.11057692307692309,
      0.8666666666666669,
      0.7647058823529411
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      107,
      24,
      19
    ],
    "_population": 82,
    "_hsl": [
      0.00946969696969697,
      0.6984126984126984,
      0.24705882352941178
    ]
  },
  "Muted": {
    "_rgb": [
      172,
      116,
      76
    ],
    "_population": 1379,
    "_hsl": [
      0.06944444444444443,
      0.3870967741935484,
      0.4862745098039216
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      53,
      38
    ],
    "_population": 950,
    "_hsl": [
      0.0625,
      0.3448275862068966,
      0.2274509803921569
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Robin-Hood.js